import { Component, OnInit,HostListener } from '@angular/core';
import {NavController} from '@ionic/angular';
import { GridBaseCase } from '../grid/grid.base.case';
import { ActivatedRoute } from '@angular/router';
import { CommonService} from '../../../service/common.service';
@Component({
  selector: 'app-img-preview',
  templateUrl: './img-preview.component.html',
  styleUrls: ['./img-preview.component.scss']
})
export class ImgPreviewComponent extends GridBaseCase implements OnInit {
  ImgPreview:any = {};
  slideOpts = {};
  timer = null;
  constructor(
    private route: ActivatedRoute,
    private navc:NavController,
    private com:CommonService
  ) { super(); 
    const ImgPreview = this.route.snapshot.queryParamMap.get("ImgPreview");
    this.ImgPreview = JSON.parse(ImgPreview);
    let arr = [];
    this.ImgPreview["imgUrl"].forEach(element => {
      // console.log(element);
      arr.push(decodeURI(element));
    });
    this.ImgPreview["imgUrl"] = arr;
    // console.log(this.ImgPreview);
  }

  ngOnInit() {
    let that = this;
    this.slideOpts = {
      zoom: true,
      preventInteractionOnTransition:true,
      initialSlide:that.ImgPreview.index
    }; 
  }
  
  // @HostListener('document:ionBackButton', ['$event'])
  // private overrideHardwareBackAction($event: any) {
  //   const that = this;
  //   $event.detail.register(100, async () => {
  //     that.com.goBack(false);
  //     return;
  //   });
  // }
 
  
  // slideTouchEnd(e){
  // }
  // slideChange(e){
  // }
  goBack(){
    let that = this;
    console.log(that.timer);
    if(that.timer){
      clearTimeout(that.timer);
      that.timer = null;
    }else{
      that.timer = setTimeout(()=>{
        that.com.goBack(false);
        // window.history.back();
        clearTimeout(that.timer);
        that.timer = null;
      },300);
    }
  }
}
